import { CALL_CSR_API } from '../../middleware/authHeaders'
import { CSR_API_ROOT } from '../../config/api'

export const CSR_GET_USERS_REQUEST = 'CSR_GET_USERS_REQUEST'
export const CSR_GET_USERS_SUCCESS = 'CSR_GET_USERS_SUCCESS'
export const CSR_GET_USERS_FAILURE = 'CSR_GET_USERS_FAILURE'

export const getUsers =
  (orgId, pageNumber, pageSize = 10, userQueryText = '', userTypeQuery = '') =>
  dispatch =>
    dispatch({
      [CALL_CSR_API]: {
        method: 'GET',
        endpoint: `${CSR_API_ROOT}/organization/${orgId}/users/?page=${pageNumber}&pageSize=${pageSize}&userQueryText=${userQueryText}&userTypeQuery=${userTypeQuery}`,
        types: [CSR_GET_USERS_REQUEST, CSR_GET_USERS_SUCCESS, CSR_GET_USERS_FAILURE],
      },
    })

// SELECTORS
export const selectUserSlice = state => state.csr.user

export const selectUsers = state => selectUserSlice(state).users

// STATE
const INITIAL_STATE = {
  users: {},
}

// REDUCERS
const user = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [CSR_GET_USERS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      users: newPayload.results,
    }),
  }[type]?.(state, payload) || state)

export default user
